import { getYoyakuAccount, getYoyakuProperty, getYoyakuRooms } from '@/libs/v1/api/client';
import Store from '@/store';

export async function loadYoyakuStore(targetName: string) {
  if (Store.getters.yoyaku.targetName === targetName) {
    return;
  }
  if (!targetName) {
    clearYoyakuStore();
    return;
  }
  try {
    const [account, property, rooms] = await Promise.all([
      getYoyakuAccount({ targetName }),
      getYoyakuProperty({ targetName }),
      getYoyakuRooms({ targetName }),
    ]);
    updateYoyakuStore(targetName, account, property, rooms);
  } catch (err) {
    console.log({ err });
    clearYoyakuStore();
  }
}

function updateYoyakuStore(targetName: any, account: any, property: any, rooms: any) {
  updateYoyakuTargetName(targetName);
  updateYoyakuAccount(account);
  updateYoyakuProperty(property);
  updateYoyakuRooms(rooms);
}

function clearYoyakuStore() {
  updateYoyakuStore(null, null, null, null);
}

function updateYoyakuTargetName(targetName: any) {
  Store.commit('updateYoyakuTargetName', targetName);
}

function updateYoyakuAccount(account: any) {
  Store.commit('updateYoyakuAccount', account);
}

function updateYoyakuProperty(property: any) {
  Store.commit('updateYoyakuProperty', property);
}

function updateYoyakuRooms(rooms: any) {
  Store.commit('updateYoyakuRooms', rooms);
}

const YOYAKU_SESSION_KEY = 'yoyakuContent';

export function loadYoyakuSession(storage: Storage = sessionStorage) {
  const value = storage.getItem(YOYAKU_SESSION_KEY);
  const session = JSON.parse(value);
  updateYoyakuSession(session);
}

export function saveYoyakuSession(session: any, storage: Storage = sessionStorage) {
  updateYoyakuSession(session);
  const value = JSON.stringify(session);
  storage.setItem(YOYAKU_SESSION_KEY, value);
}

function updateYoyakuSession(session: any) {
  Store.commit('updateYoyakuSession', session);
}
